import { Directive, forwardRef, HostAttributeToken, inject } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
@Directive({
    // tslint doesn't like multiple selectors, thinks the latter ones shoudl be camelCase
    // eslint-disable-next-line
    selector: '[validateEqual][formControlName],[validateEqual][formControl],[validateEqual][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateEqualDirective), multi: true }
    ],
    standalone: false
})
export class ValidateEqualDirective implements Validator {
    validateEqual = inject(new HostAttributeToken('validateEqual'), { optional: true });


    validate(c: AbstractControl): { [key: string]: any } {
        // self value (e.g. retype password)
        const v = c.value;

        // control value (e.g. password)
        const e = c.root.get(this.validateEqual);

        // value not equal
        if (e && v !== e.value) { return {
            validateEqual: {
                valid: false
            }
        };
        }
        return null;
    }
    registerOnValidatorChange() {
        // Nothing
    }
}
